import { apiFetcher } from "./apiFetcher";

export const mobilizeiDevicesService = {
    getPreviewerDevices,
    getPreviewerDeviceStatus,
    removePreviewerDevice,
    sendPreviewerDownloadLink,
    sendTrialPush
};

// Sends the merchant the same link that is behind the QR code, by email. The
// address is the one on his account, so there is nothing to send in the body.
function sendPreviewerDownloadLink(platformId, storeId) {
    const url = `platforms/${platformId}/stores/${storeId}/send_previewer_download_email`

    return apiFetcher(url, { method: "POST" }).then(response => response);
}

// Devices with the Visualizador connected to the store, most recently seen first:
// { devices: [{ id, os, modelName, lastAccessAt, pairedAt }] }
function getPreviewerDevices(platformId, storeId) {
    const url = `platforms/${platformId}/stores/${storeId}/previewer_devices`

    return apiFetcher(url, { method: "GET" }, false).then(response => response);
}

// since (the latest lastAccessAt the screen knows) makes the status only answer
// "connected" for a device that checked in after it.
function getPreviewerDeviceStatus(platformId, storeId, since = null) {
    const query = since ? `?since=${encodeURIComponent(since)}` : '';
    const url = `platforms/${platformId}/stores/${storeId}/previewer_devices/status${query}`

    return apiFetcher(url, { method: "GET" }, false).then(response => response);
}

function removePreviewerDevice(platformId, storeId, deviceId) {
    const url = `platforms/${platformId}/stores/${storeId}/previewer_devices/${deviceId}`

    return apiFetcher(url, { method: "DELETE" }, false).then(response => response);
}

// The onboarding sends { title, text, isCustom } to every device of the store. The
// push screen sends the whole form plus the deviceIds the merchant ticked.
function sendTrialPush(platformId, storeId, body) {
    const url = `platforms/${platformId}/stores/${storeId}/previewer_devices/send_trial_push`

    return apiFetcher(url, {
        method: "POST",
        body: JSON.stringify(body)
    }).then(response => response);
}
